export enum ActiveOrderTestIds {
  ORDER_SELECTED_MESSAGE = 'order-selected-message',
  ORDER_SELECTED_BUTTON = 'order-selected-button',
  CUSTOMER_BLOCKING_REASON_AUTOCOMPLETE = 'customer-blocking-reason-autocomplete',
  CUSTOMER_DETAILS = 'customer-details',
  ACTIVE_ORDER_HEADER_ICON = 'active-order-header-icon',
  BACK_TO_CATALOG_BUTTON = 'back-to-catalog-button',
  ORDER_BOOK_ORDERS_AUTOCOMPLETE = 'order-book-orders-autocomplete',
  ORDER_BOOK_ORDERS_AUTOCOMPLETE_OPTION = 'order-book-orders-autocomplete-option',
  ORDER_BOOK_CUSTOMERS_AUTOCOMPLETE = 'order-book-customers-autocomplete',
  ORDER_BOOK_CUSTOMERS_AUTOCOMPLETE_OPTION = 'order-book-customers-autocomplete-option',
  ORDER_BOOK_FINISH_ORDER_BUTTON = 'order-book-finish-order-button',
  ORDER_BOOK_GO_BACK = 'order-book-go-back',
  ORDER_BOOK_CREATE_ORDER_WITHOUT_CUSTOMER = 'order-book-create-order-with-customer',
  ORDER_BOOK_BADGE = 'order-book-badge',
  ORDER_BOOK_ACTIVE_ORDER_BUTTON = 'order-book-active-order-button',
  CLOSE_BUTTON = 'order-book-close-button',
  CREATE_AS_SUGGESTION_CHECKBOX = 'order-book-create-as-suggestion-checkbox',
  ACTIVE_SUGGESTED_ORDER_TITLE = 'order-book-active-suggested-order-title',
  PRODUCT_DETAILS_MODAL = 'product-details-modal',
}
